import {useMediaQuery} from "@mui/material";

export function useWindowResizeToTablet() {
  const isTablet: boolean = useMediaQuery('(min-width:769px) and (max-width:1024px)');
  return isTablet;
}
